@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(346_467_005)
internal val Res.drawable.alyn_layer_10_cry_eyebrows: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_cry_eyebrows", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-cry-eyebrows.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_896_325_805)
internal val Res.drawable.alyn_layer_10_cry_eyes_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_cry_eyes_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-cry-eyes-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_069_043_708)
internal val Res.drawable.alyn_layer_10_cry_eyes_front: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_cry_eyes_front", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-cry-eyes-front.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_865_815_384)
internal val Res.drawable.alyn_layer_10_cry_mouth: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_cry_mouth", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-cry-mouth.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_706_475_209)
internal val Res.drawable.alyn_layer_10_cry_tears: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_cry_tears", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-cry-tears.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_472_770_206)
internal val Res.drawable.alyn_layer_10_happy: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_happy", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-happy.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(134_528_389)
internal val Res.drawable.alyn_layer_10_happy_eyebrows: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_happy_eyebrows", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-happy-eyebrows.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-900_959_262)
internal val Res.drawable.alyn_layer_10_happy_mouth: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_happy_mouth", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-happy-mouth.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_825_995_113)
internal val Res.drawable.alyn_layer_10_idle: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_idle", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-idle.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_896_325_805)
internal val Res.drawable.alyn_layer_10_idle_eyes_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_idle_eyes_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-idle-eyes-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_251_150_218)
internal val Res.drawable.alyn_layer_10_idle_eyes_front: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_idle_eyes_front", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-idle-eyes-front.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_991_886_142)
internal val Res.drawable.alyn_layer_10_idle_mouth: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_idle_mouth", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-idle-mouth.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(308_930_310)
internal val Res.drawable.alyn_layer_10_perfect: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_perfect", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-perfect.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_867_733_103)
internal val Res.drawable.alyn_layer_10_perfect_cheecks: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_perfect_cheecks", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-perfect-cheecks.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(227_143_073)
internal val Res.drawable.alyn_layer_10_perfect_eyebrows: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_perfect_eyebrows", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-perfect-eyebrows.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_427_430_593)
internal val Res.drawable.alyn_layer_10_perfect_teeth: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_perfect_teeth", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-perfect-teeth.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_478_117_811)
internal val Res.drawable.alyn_layer_10_perfect_teeth_over: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_perfect_teeth_over", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-perfect-teeth-over.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_690_590_226)
internal val Res.drawable.alyn_layer_10_sad: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_sad", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-sad.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(346_467_005)
internal val Res.drawable.alyn_layer_10_sad_eyebrows: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_sad_eyebrows", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-sad-eyebrows.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_896_325_805)
internal val Res.drawable.alyn_layer_10_sad_eyes_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_sad_eyes_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-sad-eyes-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_069_043_708)
internal val Res.drawable.alyn_layer_10_sad_eyes_front: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_sad_eyes_front", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-sad-eyes-front.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_095_427_555)
internal val Res.drawable.alyn_layer_10_sad_mouth: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_sad_mouth", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-sad-mouth.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_797_519_261)
internal val Res.drawable.alyn_layer_10_serious: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_serious", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-serious.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_443_761_522)
internal val Res.drawable.alyn_layer_10_serious_eyebrows: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_serious_eyebrows", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-serious-eyebrows.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_896_325_805)
internal val Res.drawable.alyn_layer_10_serious_eyes_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_serious_eyes_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-serious-eyes-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_251_150_218)
internal val Res.drawable.alyn_layer_10_serious_eyes_front: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_serious_eyes_front", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-serious-eyes-front.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-464_873_259)
internal val Res.drawable.alyn_layer_10_serious_mouth: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_serious_mouth", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-serious-mouth.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(537_110_619)
internal val Res.drawable.alyn_layer_10_surprised: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_surprised", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-surprised.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-97_688_333)
internal val Res.drawable.alyn_layer_10_surprised_eyebrows: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_surprised_eyebrows", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-surprised-eyebrows.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_896_325_805)
internal val Res.drawable.alyn_layer_10_surprised_eyes_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_surprised_eyes_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-surprised-eyes-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_251_150_218)
internal val Res.drawable.alyn_layer_10_surprised_eyes_front: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_surprised_eyes_front", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-surprised-eyes-front.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_487_476_441)
internal val Res.drawable.alyn_layer_10_surprised_mouth: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_surprised_mouth", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-surprised-mouth.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_386_634_341)
internal val Res.drawable.alyn_layer_10_surprised_tongue: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_surprised_tongue", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-surprised-tongue.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_194_925_072)
internal val Res.drawable.alyn_layer_1_orecchino: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_1_orecchino", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-1-orecchino.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_682_484_166)
internal val Res.drawable.alyn_layer_2_maglietta: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_2_maglietta", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-2-maglietta.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_412_506_245)
internal val Res.drawable.alyn_layer_2_maglietta_collo_alto: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_2_maglietta_collo_alto", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-2-maglietta-collo-alto.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(970_949_926)
internal val Res.drawable.alyn_layer_3_orecchio: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_3_orecchio", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-3-orecchio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_060_959_116)
internal val Res.drawable.alyn_layer_4_barra_cappello: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_4_barra_cappello", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-4-barra-cappello.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_681_536_851)
internal val Res.drawable.alyn_layer_5_cappello: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5_cappello", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-5-cappello.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_806_839_629)
internal val Res.drawable.alyn_layer_5_cappello_accento_basco: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5_cappello_accento_basco", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-5-cappello-accento-basco.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(429_148_297)
internal val Res.drawable.alyn_layer_5_cappello_basco: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5_cappello_basco", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-5-cappello-basco.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-867_399_669)
internal val Res.drawable.alyn_layer_5_cappello_viking: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5_cappello_viking", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_layer_5_cappello_viking.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_338_783_283)
internal val Res.drawable.alyn_layer_5_cappello_viking_accent: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5_cappello_viking_accent", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_layer_5_cappello_viking_accent.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_891_639_556)
internal val Res.drawable.alyn_layer_5_cappello_viking_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5_cappello_viking_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-5-cappello-viking-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_265_191_599)
internal val Res.drawable.alyn_layer_5_cappello_viking_horn: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5_cappello_viking_horn", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_layer_5_cappello_viking_horn.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_652_178_752)
internal val Res.drawable.alyn_layer_5b_cappello: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_5b_cappello", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-5b-cappello.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_188_136_507)
internal val Res.drawable.alyn_layer_6_capelli_front: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_6_capelli_front", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-6-capelli-front.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_725_240_670)
internal val Res.drawable.alyn_layer_7_faccia: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_7_faccia", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-7-faccia.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_237_040_807)
internal val Res.drawable.alyn_layer_7b_collo: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_7b_collo", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-7b-collo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_431_440_457)
internal val Res.drawable.alyn_layer_7b_faccia_ombra: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_7b_faccia_ombra", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-7b-faccia-ombra.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-797_360_547)
internal val Res.drawable.alyn_layer_7b_naso: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_7b_naso", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-7b-naso.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_076_926_446)
internal val Res.drawable.alyn_layer_8_capelli_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_8_capelli_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-8-capelli-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(536_773_358)
internal val Res.drawable.alyn_layer_8b_capelli_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_8b_capelli_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-8b-capelli-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_198_160_276)
internal val Res.drawable.alyn_layer_9_cappello_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_9_cappello_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-9-cappello-back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(454_037_636)
internal val Res.drawable.amenamhat: DrawableResource by lazy {
      DrawableResource("drawable:amenamhat", setOf(
        ResourceItem(setOf(), "${MD}drawable/amenamhat.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-817_676_610)
internal val Res.drawable.attrezzi_scriba: DrawableResource by lazy {
      DrawableResource("drawable:attrezzi_scriba", setOf(
        ResourceItem(setOf(), "${MD}drawable/attrezzi_scriba.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-495_836_180)
internal val Res.drawable.auto_stories: DrawableResource by lazy {
      DrawableResource("drawable:auto_stories", setOf(
        ResourceItem(setOf(), "${MD}drawable/auto_stories.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_122_191_603)
internal val Res.drawable.avvoltoio: DrawableResource by lazy {
      DrawableResource("drawable:avvoltoio", setOf(
        ResourceItem(setOf(), "${MD}drawable/avvoltoio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-904_647_277)
internal val Res.drawable.bacino_acqua_1: DrawableResource by lazy {
      DrawableResource("drawable:bacino_acqua_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/bacino_acqua_1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_122_138_018)
internal val Res.drawable.bacino_acqua_2: DrawableResource by lazy {
      DrawableResource("drawable:bacino_acqua_2", setOf(
        ResourceItem(setOf(), "${MD}drawable/bacino_acqua_2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_506_166_619)
internal val Res.drawable.bacino_acqua_3: DrawableResource by lazy {
      DrawableResource("drawable:bacino_acqua_3", setOf(
        ResourceItem(setOf(), "${MD}drawable/bacino_acqua_3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_093_122_492)
internal val Res.drawable.bacino_acqua_4: DrawableResource by lazy {
      DrawableResource("drawable:bacino_acqua_4", setOf(
        ResourceItem(setOf(), "${MD}drawable/bacino_acqua_4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-321_106_632)
internal val Res.drawable.basco: DrawableResource by lazy {
      DrawableResource("drawable:basco", setOf(
        ResourceItem(setOf(), "${MD}drawable/basco.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_631_907_983)
internal val Res.drawable.bocca: DrawableResource by lazy {
      DrawableResource("drawable:bocca", setOf(
        ResourceItem(setOf(), "${MD}drawable/bocca.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_981_867_279)
internal val Res.drawable.book: DrawableResource by lazy {
      DrawableResource("drawable:book", setOf(
        ResourceItem(setOf(), "${MD}drawable/book.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-456_436_665)
internal val Res.drawable.braccio: DrawableResource by lazy {
      DrawableResource("drawable:braccio", setOf(
        ResourceItem(setOf(), "${MD}drawable/braccio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_102_016_885)
internal val Res.drawable.buco: DrawableResource by lazy {
      DrawableResource("drawable:buco", setOf(
        ResourceItem(setOf(), "${MD}drawable/buco.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_077_635_476)
internal val Res.drawable.canna: DrawableResource by lazy {
      DrawableResource("drawable:canna", setOf(
        ResourceItem(setOf(), "${MD}drawable/canna.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-511_517_294)
internal val Res.drawable.canne: DrawableResource by lazy {
      DrawableResource("drawable:canne", setOf(
        ResourceItem(setOf(), "${MD}drawable/canne.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_083_992_295)
internal val Res.drawable.cat_idle: DrawableResource by lazy {
      DrawableResource("drawable:cat_idle", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_idle.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_384_936_579)
internal val Res.drawable.cat_mummy: DrawableResource by lazy {
      DrawableResource("drawable:cat_mummy", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_mummy.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-41_807_745)
internal val Res.drawable.cat_ohno: DrawableResource by lazy {
      DrawableResource("drawable:cat_ohno", setOf(
        ResourceItem(setOf(), "${MD}drawable/cat_ohno.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-561_878_819)
internal val Res.drawable.cesta_con_manico: DrawableResource by lazy {
      DrawableResource("drawable:cesta_con_manico", setOf(
        ResourceItem(setOf(), "${MD}drawable/cesta_con_manico.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-469_286_095)
internal val Res.drawable.chiavistello: DrawableResource by lazy {
      DrawableResource("drawable:chiavistello", setOf(
        ResourceItem(setOf(), "${MD}drawable/chiavistello.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_235_095_301)
internal val Res.drawable.cielo: DrawableResource by lazy {
      DrawableResource("drawable:cielo", setOf(
        ResourceItem(setOf(), "${MD}drawable/cielo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_751_199_673)
internal val Res.drawable.circle: DrawableResource by lazy {
      DrawableResource("drawable:circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_327_974_188)
internal val Res.drawable.circle_ko: DrawableResource by lazy {
      DrawableResource("drawable:circle_ko", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_ko.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-772_577_484)
internal val Res.drawable.circle_ok: DrawableResource by lazy {
      DrawableResource("drawable:circle_ok", setOf(
        ResourceItem(setOf(), "${MD}drawable/circle_ok.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-894_421_464)
internal val Res.drawable.cobra: DrawableResource by lazy {
      DrawableResource("drawable:cobra", setOf(
        ResourceItem(setOf(), "${MD}drawable/cobra.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_717_403_771)
internal val Res.drawable.coin: DrawableResource by lazy {
      DrawableResource("drawable:coin", setOf(
        ResourceItem(setOf(), "${MD}drawable/coin.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_294_451_488)
internal val Res.drawable.coins: DrawableResource by lazy {
      DrawableResource("drawable:coins", setOf(
        ResourceItem(setOf(), "${MD}drawable/coins.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(798_940_452)
internal val Res.drawable.corda: DrawableResource by lazy {
      DrawableResource("drawable:corda", setOf(
        ResourceItem(setOf(), "${MD}drawable/corda.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(516_792_587)
internal val Res.drawable.corner: DrawableResource by lazy {
      DrawableResource("drawable:corner", setOf(
        ResourceItem(setOf(), "${MD}drawable/corner.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-787_274_145)
internal val Res.drawable.corona_rossa: DrawableResource by lazy {
      DrawableResource("drawable:corona_rossa", setOf(
        ResourceItem(setOf(), "${MD}drawable/corona_rossa.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(40_034_686)
internal val Res.drawable.cyclope: DrawableResource by lazy {
      DrawableResource("drawable:cyclope", setOf(
        ResourceItem(setOf(), "${MD}drawable/cyclope.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_055_188_438)
internal val Res.drawable.draw_abstract: DrawableResource by lazy {
      DrawableResource("drawable:draw_abstract", setOf(
        ResourceItem(setOf(), "${MD}drawable/draw_abstract.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-892_803_339)
internal val Res.drawable.egypt: DrawableResource by lazy {
      DrawableResource("drawable:egypt", setOf(
        ResourceItem(setOf(), "${MD}drawable/egypt.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(368_297_096)
internal val Res.drawable.favourite_off: DrawableResource by lazy {
      DrawableResource("drawable:favourite_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/favourite_off.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(330_599_992)
internal val Res.drawable.favourite_on: DrawableResource by lazy {
      DrawableResource("drawable:favourite_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/favourite_on.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_653_124_426)
internal val Res.drawable.fianco_collina: DrawableResource by lazy {
      DrawableResource("drawable:fianco_collina", setOf(
        ResourceItem(setOf(), "${MD}drawable/fianco_collina.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_722_934_669)
internal val Res.drawable.fire: DrawableResource by lazy {
      DrawableResource("drawable:fire", setOf(
        ResourceItem(setOf(), "${MD}drawable/fire.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_960_342_041)
internal val Res.drawable.fire_no: DrawableResource by lazy {
      DrawableResource("drawable:fire_no", setOf(
        ResourceItem(setOf(), "${MD}drawable/fire_no.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_101_170_453)
internal val Res.drawable.fluorescent: DrawableResource by lazy {
      DrawableResource("drawable:fluorescent", setOf(
        ResourceItem(setOf(), "${MD}drawable/fluorescent.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_284_339_025)
internal val Res.drawable.full: DrawableResource by lazy {
      DrawableResource("drawable:full", setOf(
        ResourceItem(setOf(), "${MD}drawable/full.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(679_229_009)
internal val Res.drawable.gamba: DrawableResource by lazy {
      DrawableResource("drawable:gamba", setOf(
        ResourceItem(setOf(), "${MD}drawable/gamba.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_872_183_370)
internal val Res.drawable.gold: DrawableResource by lazy {
      DrawableResource("drawable:gold", setOf(
        ResourceItem(setOf(), "${MD}drawable/gold.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_149_963_978)
internal val Res.drawable.gufo: DrawableResource by lazy {
      DrawableResource("drawable:gufo", setOf(
        ResourceItem(setOf(), "${MD}drawable/gufo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-994_716_676)
internal val Res.drawable.hathor: DrawableResource by lazy {
      DrawableResource("drawable:hathor", setOf(
        ResourceItem(setOf(), "${MD}drawable/hathor.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_137_078_559)
internal val Res.drawable.horus: DrawableResource by lazy {
      DrawableResource("drawable:horus", setOf(
        ResourceItem(setOf(), "${MD}drawable/horus.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable11Resources(map: MutableMap<String, DrawableResource>) {
  map.put("alyn_layer_10_cry_eyebrows", Res.drawable.alyn_layer_10_cry_eyebrows)
  map.put("alyn_layer_10_cry_eyes_back", Res.drawable.alyn_layer_10_cry_eyes_back)
  map.put("alyn_layer_10_cry_eyes_front", Res.drawable.alyn_layer_10_cry_eyes_front)
  map.put("alyn_layer_10_cry_mouth", Res.drawable.alyn_layer_10_cry_mouth)
  map.put("alyn_layer_10_cry_tears", Res.drawable.alyn_layer_10_cry_tears)
  map.put("alyn_layer_10_happy", Res.drawable.alyn_layer_10_happy)
  map.put("alyn_layer_10_happy_eyebrows", Res.drawable.alyn_layer_10_happy_eyebrows)
  map.put("alyn_layer_10_happy_mouth", Res.drawable.alyn_layer_10_happy_mouth)
  map.put("alyn_layer_10_idle", Res.drawable.alyn_layer_10_idle)
  map.put("alyn_layer_10_idle_eyes_back", Res.drawable.alyn_layer_10_idle_eyes_back)
  map.put("alyn_layer_10_idle_eyes_front", Res.drawable.alyn_layer_10_idle_eyes_front)
  map.put("alyn_layer_10_idle_mouth", Res.drawable.alyn_layer_10_idle_mouth)
  map.put("alyn_layer_10_perfect", Res.drawable.alyn_layer_10_perfect)
  map.put("alyn_layer_10_perfect_cheecks", Res.drawable.alyn_layer_10_perfect_cheecks)
  map.put("alyn_layer_10_perfect_eyebrows", Res.drawable.alyn_layer_10_perfect_eyebrows)
  map.put("alyn_layer_10_perfect_teeth", Res.drawable.alyn_layer_10_perfect_teeth)
  map.put("alyn_layer_10_perfect_teeth_over", Res.drawable.alyn_layer_10_perfect_teeth_over)
  map.put("alyn_layer_10_sad", Res.drawable.alyn_layer_10_sad)
  map.put("alyn_layer_10_sad_eyebrows", Res.drawable.alyn_layer_10_sad_eyebrows)
  map.put("alyn_layer_10_sad_eyes_back", Res.drawable.alyn_layer_10_sad_eyes_back)
  map.put("alyn_layer_10_sad_eyes_front", Res.drawable.alyn_layer_10_sad_eyes_front)
  map.put("alyn_layer_10_sad_mouth", Res.drawable.alyn_layer_10_sad_mouth)
  map.put("alyn_layer_10_serious", Res.drawable.alyn_layer_10_serious)
  map.put("alyn_layer_10_serious_eyebrows", Res.drawable.alyn_layer_10_serious_eyebrows)
  map.put("alyn_layer_10_serious_eyes_back", Res.drawable.alyn_layer_10_serious_eyes_back)
  map.put("alyn_layer_10_serious_eyes_front", Res.drawable.alyn_layer_10_serious_eyes_front)
  map.put("alyn_layer_10_serious_mouth", Res.drawable.alyn_layer_10_serious_mouth)
  map.put("alyn_layer_10_surprised", Res.drawable.alyn_layer_10_surprised)
  map.put("alyn_layer_10_surprised_eyebrows", Res.drawable.alyn_layer_10_surprised_eyebrows)
  map.put("alyn_layer_10_surprised_eyes_back", Res.drawable.alyn_layer_10_surprised_eyes_back)
  map.put("alyn_layer_10_surprised_eyes_front", Res.drawable.alyn_layer_10_surprised_eyes_front)
  map.put("alyn_layer_10_surprised_mouth", Res.drawable.alyn_layer_10_surprised_mouth)
  map.put("alyn_layer_10_surprised_tongue", Res.drawable.alyn_layer_10_surprised_tongue)
  map.put("alyn_layer_1_orecchino", Res.drawable.alyn_layer_1_orecchino)
  map.put("alyn_layer_2_maglietta", Res.drawable.alyn_layer_2_maglietta)
  map.put("alyn_layer_2_maglietta_collo_alto", Res.drawable.alyn_layer_2_maglietta_collo_alto)
  map.put("alyn_layer_3_orecchio", Res.drawable.alyn_layer_3_orecchio)
  map.put("alyn_layer_4_barra_cappello", Res.drawable.alyn_layer_4_barra_cappello)
  map.put("alyn_layer_5_cappello", Res.drawable.alyn_layer_5_cappello)
  map.put("alyn_layer_5_cappello_accento_basco", Res.drawable.alyn_layer_5_cappello_accento_basco)
  map.put("alyn_layer_5_cappello_basco", Res.drawable.alyn_layer_5_cappello_basco)
  map.put("alyn_layer_5_cappello_viking", Res.drawable.alyn_layer_5_cappello_viking)
  map.put("alyn_layer_5_cappello_viking_accent", Res.drawable.alyn_layer_5_cappello_viking_accent)
  map.put("alyn_layer_5_cappello_viking_back", Res.drawable.alyn_layer_5_cappello_viking_back)
  map.put("alyn_layer_5_cappello_viking_horn", Res.drawable.alyn_layer_5_cappello_viking_horn)
  map.put("alyn_layer_5b_cappello", Res.drawable.alyn_layer_5b_cappello)
  map.put("alyn_layer_6_capelli_front", Res.drawable.alyn_layer_6_capelli_front)
  map.put("alyn_layer_7_faccia", Res.drawable.alyn_layer_7_faccia)
  map.put("alyn_layer_7b_collo", Res.drawable.alyn_layer_7b_collo)
  map.put("alyn_layer_7b_faccia_ombra", Res.drawable.alyn_layer_7b_faccia_ombra)
  map.put("alyn_layer_7b_naso", Res.drawable.alyn_layer_7b_naso)
  map.put("alyn_layer_8_capelli_back", Res.drawable.alyn_layer_8_capelli_back)
  map.put("alyn_layer_8b_capelli_back", Res.drawable.alyn_layer_8b_capelli_back)
  map.put("alyn_layer_9_cappello_back", Res.drawable.alyn_layer_9_cappello_back)
  map.put("amenamhat", Res.drawable.amenamhat)
  map.put("attrezzi_scriba", Res.drawable.attrezzi_scriba)
  map.put("auto_stories", Res.drawable.auto_stories)
  map.put("avvoltoio", Res.drawable.avvoltoio)
  map.put("bacino_acqua_1", Res.drawable.bacino_acqua_1)
  map.put("bacino_acqua_2", Res.drawable.bacino_acqua_2)
  map.put("bacino_acqua_3", Res.drawable.bacino_acqua_3)
  map.put("bacino_acqua_4", Res.drawable.bacino_acqua_4)
  map.put("basco", Res.drawable.basco)
  map.put("bocca", Res.drawable.bocca)
  map.put("book", Res.drawable.book)
  map.put("braccio", Res.drawable.braccio)
  map.put("buco", Res.drawable.buco)
  map.put("canna", Res.drawable.canna)
  map.put("canne", Res.drawable.canne)
  map.put("cat_idle", Res.drawable.cat_idle)
  map.put("cat_mummy", Res.drawable.cat_mummy)
  map.put("cat_ohno", Res.drawable.cat_ohno)
  map.put("cesta_con_manico", Res.drawable.cesta_con_manico)
  map.put("chiavistello", Res.drawable.chiavistello)
  map.put("cielo", Res.drawable.cielo)
  map.put("circle", Res.drawable.circle)
  map.put("circle_ko", Res.drawable.circle_ko)
  map.put("circle_ok", Res.drawable.circle_ok)
  map.put("cobra", Res.drawable.cobra)
  map.put("coin", Res.drawable.coin)
  map.put("coins", Res.drawable.coins)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("corda", Res.drawable.corda)
  map.put("corner", Res.drawable.corner)
  map.put("corona_rossa", Res.drawable.corona_rossa)
  map.put("cyclope", Res.drawable.cyclope)
  map.put("draw_abstract", Res.drawable.draw_abstract)
  map.put("egypt", Res.drawable.egypt)
  map.put("favourite_off", Res.drawable.favourite_off)
  map.put("favourite_on", Res.drawable.favourite_on)
  map.put("fianco_collina", Res.drawable.fianco_collina)
  map.put("fire", Res.drawable.fire)
  map.put("fire_no", Res.drawable.fire_no)
  map.put("fluorescent", Res.drawable.fluorescent)
  map.put("full", Res.drawable.full)
  map.put("gamba", Res.drawable.gamba)
  map.put("gold", Res.drawable.gold)
  map.put("gufo", Res.drawable.gufo)
  map.put("hathor", Res.drawable.hathor)
  map.put("horus", Res.drawable.horus)
}
